<app-spinner *ngIf="pageLoading"></app-spinner>

<div class="container-fluid user-choice" *ngIf="!pageLoading">
  <div class="row justify-content-center mt-3">
    <div class="col-11 col-md-8 col-lg-5 col-xl-4 section-bc p-2">
      <ng-container *ngFor="let u of users">
        <ng-container *ngFor="let ag of u.aggregations">
          <div *ngIf="!u.external" id="select-user"
            class="row justify-content-center p-2 users-login-row cursor-pointer white-bg m-2 rounded rounded-900"
            (click)="selectUser(u,ag.unit)">
            <div class="col-2 align-self-center">
              <img class="img-fluid" src="./assets/icons/social.svg" alt="{{u?.uida}}">
            </div>
            <div class="col-10 align-self-center">
              <div class="row justify-content-start p-1 flex-md-nowrap">
                <div class="font-weight-bolder" style="width: 70px">{{'PAGE.SEARCH_PRODUCT.FILTERS_LABELS.UNIT' |
                  translate}}:</div>
                <ng-container *ngIf="u.aggregations.length > 1; else oneUnit">
                  <div class="ml-1 d-block text-truncate">{{u.unit}} / {{ag.unit}}</div>
                </ng-container>
                <ng-template #oneUnit>
                  <div class="ml-1 d-block text-truncate">{{u.unit}} </div>
                </ng-template>
              </div>
              <div class="row justify-content-start p-1 flex-md-nowrap">
                <div class="font-weight-bolder" style="width: 70px">{{'LABEL.ROLE' | translate}}:</div>
                <ng-container *ngFor="let role of ag.roles">
                  <ng-container *ngIf="u.appId === AppIdConstants.SAC_RES">
                    <div class="ml-1 d-block text-truncate"
                      *ngIf="role.id === UserPrimaryRoleConstants.ORS || role.id === UserPrimaryRoleConstants.OPV">
                      <span class="mr-1 text-truncate d-block">{{'ROLE.' + role.id | translate}}</span>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="u.appId === AppIdConstants.SAC_CALLCENTER">
                    <div class="ml-1 d-block text-truncate" *ngIf="role.id === UserPrimaryRoleConstants.OCC">
                      <span class="mr-1 text-truncate d-block">{{'ROLE.' + role.id | translate}}</span>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>

      </ng-container>
    </div>
  </div>
</div>
<div class="row justify-content-center">
  <button class="btn btn-outline-danger m-3" (click)="logout()">{{'SIDEBAR.USER.LOGOUT' | translate}}</button>
</div>